export default {
    idw: '1',
    id_web: 'visanetgt_transexpress',
    key_web: 'eb395bb1-8dfa-46eb-af8b-aa28897fdd39',
    secret_web: 'l8xMjp2hoylBbq+4RQUJ08UVd7d5/wGfrX7E+1/yMPU=',
    idi: '3',
    id_imp: 'visanetgt_telefacsimil',
    key_imp: 'daa3ef15-785a-4ffa-be8d-6f8a9c64193b',
    secret_imp: 'VH2rFRadvIJr0ofmoeKSJOqLBTsLumAgukSuihBz0NM='
};